<template>
   <div>
      <div class="box">
   <!-- 图片库图片 -->
      <div>
       添加图片：<el-button style="width:150px" @click="imglibrary(1,scmCompanyid2,userName2)">选择文件</el-button>
         <el-dialog v-dialogDrag title="图片库" :visible.sync="dialogImgregualte" width='50%'>
         <div class="mapDepot">
         <br />
         <div class="boxUpload">
            <div v-for="(item,index) in srcList" :key="index" class="demo-image__preview">
               <el-image
                  style="width: 100px; height: 100px;"
                  :src="item.link"
                  :preview-src-list="raylist"
               >
               </el-image>
               <div class="checksty">
                  <el-checkbox-group v-model="checkedCities" :max="1" @change="clicheck(item)">
                     <el-checkbox :label="item.UploadFile_id" ><br /></el-checkbox>
                  </el-checkbox-group>
               </div>
            </div>
         </div>
         <div>
            <el-pagination
            background
            @current-change="currentChangeHandle2"
            :current-page="currentPage2"
            :page-size="pageSize2"
            layout="total, prev, pager, next, slot, jumper"
            :total="currentPage5"
            >
            <span slot style="width: 40px;color: dimgrey">
               <label><input name="Fruit" type="checkbox" value="" v-model="checkedc" @change="all2" />显示全部</label>
            </span>
           </el-pagination>
           <br />
            <el-button size="small" type="primary" @click="callOff">取消</el-button>
            <el-button size="small" type="primary" @click="confirmin">确定</el-button>
         </div>
         </div>
         </el-dialog>
      </div>
      <!-- 图片链接 -->
      <div class="ImageLinks">
         <div>
            图片链接路径：
         </div>
         <el-input v-model="interlinkage.link" placeholder="请输入链接"></el-input>
      </div>
      <!--  -->
      <div class="ImageLinks">
         <div>
            图片序号：
         </div>
         <el-input v-model="serialNumber" placeholder="请输入序号"></el-input>
      </div>
      <!--保存 -->
      <div class="save" @click="preserve"><el-button>存</el-button></div>
     </div>
     <br />
     <!-- 更换图片设置 -->
     <el-row>
      <el-col :span="4" v-for="(item, index) in boxImg" :key="index" :offset="index > 0 ? 2 : 0">
         <el-card :body-style="{ padding: '0px' }">
            <el-upload
               class="avatar-uploader"
               action="https://jsonplaceholder.typicode.com/posts/"
               :show-file-list="false"
               :on-success="handleAvatarSuccess"
               :before-upload="beforeAvatarUpload">
               <img v-if="imageUrl" :src="item.link" class="avatar">
               <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div style="padding: 14px;">
               <span>更换图片：</span>
               <div class="bottom clearfix">
                  <el-button type="text" @click="imglibrary(1,scmCompanyid2,userName2)">选择文件</el-button>
                  <el-button type="text" class="button">上传</el-button>
               </div>
               <div class="inptbox">
                   <p>序号：</p>
                   <p><el-input class="inpt" v-model="sequenceNumber" placeholder="请输入序号"></el-input></p>
                </div>
                <br />
                <div class="inptbox">
                   <p>链接：</p>
                   <p><el-input class="inpt" v-model="item.link" placeholder="请输入链接"></el-input></p>
                </div>
                <br />
                <div class="btn">
                   <el-button type="primary">修改</el-button>
                   <el-button type="danger">删除</el-button>
                </div>
            </div>
         </el-card>
      </el-col>
    </el-row>
   </div>
</template>
<script>
   import {backbrary} from "../../../static/API/API.js";
   export default {
     data() {
       return {
         // 序号
         sequenceNumber:'',
         imageUrl: '',
         // 选中图片的值
         checkedCities:[],
         // 图片库
         srcList: [],
         raylist:[],
         // 图片链接
         interlinkage: '',
         // 选中图片信息
         interlinkage: {},
         // 选中图片信息的数组
         boxImg:[],
         //图片序号
         serialNumber:'',
         // 图片设置
   
         // 图片库
         dialogImgregualte:false,
         //分页和当前页
         currentPage0:10,
         currentPage2:1,
         pageSize2: 1,
         currentPage5:0,
         // 图片库点击事件的参数
         scmCompanyid2: '',
         userName2:'',
         // 图片库分页全选复选框
         checkedc: false,
       };
     },
     methods:{
     // 点击保存
      preserve(){
      // 创建人id 板块id 内容页id 排序 商品id
      
         console.log(this.serialNumber,'序号');
         this.sequenceNumber = this.serialNumber
         console.log(this.interlinkage,'this.interlinkage');
         this.boxImg.push(this.interlinkage)
         console.log(this.boxImg,'this.boxImg');
      },     
      // 上传图片组件
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 20;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      // 选中图片后的处理 点击选中图片后val拿到图片值，
      clicheck(val){
         console.log(val,'valvalvalvlal');
         this.interlinkage = val
      //   this.numlist.push(val.link)//图片url
      //   this.checkedUrl = JSON.stringify(this.numlist)
      //   console.log(JSON.stringify(this.numlist),'this.checkedUrl');
      },
         // 图片库显示全部图片
         all2(){
        if (this.checkedc) {
          this.currentPage0 = 'all'
          this.imglibrary(1, this.scmCompanyid2, this.userName2)
        } else {
          this.currentPage0 = 10
          this.imglibrary(1, this.scmCompanyid2, this.userName2)
        }
      },
      //图片库
      imglibrary(e, companyid2, name2){
      this.dialogImgregualte = true
      let params = new URLSearchParams();
        if (e) {
          params.append('page_number', e)
        } else {
          params.append('page_number', this.currentPage2)
        }
        params.append('page_size',this.currentPage0);
        params.append('file_type', 'photo');
        params.append('companyid', sessionStorage.getItem('companyid'));
        this.$axios.get(backbrary,{
          params
        }).then(res =>{
          let arr = []
          let listlist = []
          this.currentPage5 = Number(res.data[0]['PageNums'])
          res.data[0].pagedata.forEach(item =>{
              arr.push(item)
              listlist.push(item.link)
          })
          this.srcList = arr
          this.raylist = listlist
        })
      },
      //图片库分页
      currentChangeHandle2(val){
        this.currentPage2 = val
        this.imglibrary(this.currentPage2, this.scmCompanyid2, this.userName2)
      },
         //   取消按钮
      callOff(){
      },
      // 确定
      confirmin(){
         this.dialogImgregualte = false
      }
     },
   };
 </script>
 <style scoped>
    .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width:100%;
    height: 268px;
    line-height: 268px;
    text-align: center;
  }
  .avatar {
    width:100%;
    height: 268px;
    display: block;
  }
   /* 保存按钮 */
   .save{
      margin-left: 20px;
   }
   .box{
      display: flex;
      align-items: center;
   }
/* 图片链接 */
 .ImageLinks{
   display: flex;
   align-items: center;
   margin: 0 20px;
 }
.el-input {
    width: 300px;
  }
  /* 图片设置 */
  .bottom {
   display: flex;
   align-items: center;
   justify-content: space-between;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  /* .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  } */
  /* 图片库 */
  .boxUpload{
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* justify-content: space-between; */
}
.demo-image__preview{
    position: relative;
    margin-right: 5px;
  }
 .checksty{
    position: absolute;
    top: 0;
    right: 0;
  }
  .inptbox{
    display: flex;
    align-items: center;
   }
   .inptbox .inpt{
    width:100%;
   }
   .btn{
    display: flex;
    justify-content: space-between;
   }
 </style>


// WEBPACK FOOTER //
// src/views/public/pictureSet.vue